/** Allinea contatore e data: se c'è ultimo contatto, il numero non può essere 0. */
export function effectiveNumeroContatti(
  numeroContatti: number | null | undefined,
  dataUltimoContatto?: string | null
): number {
  const n = numeroContatti ?? 0;
  if (dataUltimoContatto && n < 1) return 1;
  return n;
}
